import { useState } from 'react';
import controllerConfigs from '../configs';
import { useTranslation } from 'react-i18next';
import AuthModuleFactory from '@core/domain/Auth';
import AppDispatcher from '@app/events/app-commander';
import { EventBusFactory } from '@utilities/event-bus';
import StorageAbstractFactory from '@infrastructure/cache';

const eventBus = EventBusFactory.resolve('global');

const getSiteKeyUseCase = AuthModuleFactory.createGetRecaptchaSiteKeyUseCase();

export default function loginProvider({ Page, formManager, loginUseCase }) {
  const controllers = formManager.initControllers(controllerConfigs);

  return function (props) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleOnSubmit = ev => {
      ev.preventDefault();

      StorageAbstractFactory.defineGlobalStorage('local');

      if (!formManager.isValid()) {
        formManager.setControllerState('captchaToken', Date.now());
        return;
      }

      setIsLoading(true);

      const { fiscalId, password, captchaToken } = formManager.getData();

      loginUseCase
        .execute({ fiscalId, password, captchaToken })
        .then(() => {
          eventBus.dispatch('login-success');
          AppDispatcher.visitPage({ path: '/' });
        })
        .catch(() => {
          getSiteKeyUseCase.execute();
          // Hackie solution: Pls think in a better one
          formManager.setControlVisibility('captchaToken', 'view');
          setTimeout(() => {
            formManager.setControlVisibility('captchaToken', 'edit');
          }, 10);
          formManager.setControllerState('captchaToken', Date.now());
          AppDispatcher.showToast({ mode: 'error', message: 'Unauthorized' });
        })
        .finally(() => setIsLoading(false));
    };

    return <Page {...props} t={t} isLoading={isLoading} controllers={controllers} handleOnSubmit={handleOnSubmit} />;
  };
}
